import { PropsWithChildren } from 'react'
import { useAuth } from '@clerk/clerk-react'
import { Navigate, useLocation } from 'react-router'
import { Loader2 } from 'lucide-react'

import { UserProvider } from '@/entities/user';

export function ProtectedRoute({ children }: PropsWithChildren) {
  const { isSignedIn, isLoaded, orgId } = useAuth()
  const location = useLocation()

  if (!isLoaded) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    )
  }

  if (!isSignedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return (
    <UserProvider key={orgId} orgId={orgId}>
      {children}
    </UserProvider>
  );
}